/* Header mini-cart dropdown (Ella parity).
   - Reveals on hover (CSS) and on click of the cart link (toggles).
   - Rebuilds its contents from /cart.js on open and after every qty change /
     clear, so it stays in sync without a page reload.
   The server-rendered markup (snippets/header-cart-dropdown.liquid) is the
   initial state and must mirror buildBody() below. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function imgFor(it) {
    if (!it.image) return '';
    var src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
    return '<img src="' + src + '" alt="" width="72" height="72" loading="lazy">';
  }

  function buildBody(cart, routes) {
    if (!cart || cart.item_count === 0) {
      return (
        '<div class="hcd__head">' +
          '<span class="hcd__title">Your Cart (<span data-hcd-count>0</span>)</span>' +
          '<button type="button" class="hcd__close" aria-label="Close" data-hcd-close>&times;</button>' +
        '</div>' +
        '<p class="hcd__empty">Your cart is empty.</p>' +
        '<a href="' + routes.all + '" class="hcd__continue">Continue shopping</a>'
      );
    }
    var items = cart.items.map(function (it, i) {
      return (
        '<li class="hcd__item" data-hcd-item data-line="' + (i + 1) + '">' +
          '<a href="' + it.url + '" class="hcd__item-img">' + imgFor(it) + '</a>' +
          '<div class="hcd__item-right">' +
            '<a href="' + it.url + '" class="hcd__item-name">' + (it.product_title || it.title) + '</a>' +
            '<span class="hcd__item-price">' + money(it.final_line_price) + '</span>' +
            '<div class="hcd__stepper">' +
              '<input type="text" class="hcd__stepper-input" value="' + it.quantity + '" data-hcd-qty readonly aria-label="Quantity">' +
              '<span class="hcd__stepper-arrows">' +
                '<button type="button" data-hcd-inc aria-label="Increase quantity">▲</button>' +
                '<button type="button" data-hcd-dec aria-label="Decrease quantity">▼</button>' +
              '</span>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
    var label = cart.item_count === 1 ? 'item' : 'items';
    return (
      '<div class="hcd__head">' +
        '<span class="hcd__count">' + cart.item_count + ' ' + label + '</span>' +
        '<button type="button" class="hcd__clear" data-hcd-clear>Clear Cart</button>' +
      '</div>' +
      '<ul class="hcd__items" role="list">' + items + '</ul>' +
      '<div class="hcd__row hcd__row--total"><span class="hcd__row-label">Total</span><span class="hcd__row-value">' + money(cart.total_price) + '</span></div>' +
      '<div class="hcd__row hcd__row--shipping"><span class="hcd__row-label">Shipping</span><span class="hcd__row-note">Taxes and shipping fee will be calculated at checkout</span></div>' +
      '<div class="hcd__ctas">' +
        '<a href="/checkout" class="hcd__checkout">Checkout</a>' +
        '<a href="' + routes.cart + '" class="hcd__viewcart"><span>View Cart</span><span class="hcd__viewcart-price">' + money(cart.total_price) + '</span></a>' +
      '</div>' +
      '<a href="/checkout" class="hcd__afterpay" aria-label="Afterpay available"><span class="hcd__afterpay-word">afterpay</span></a>'
    );
  }

  function init() {
    var wrapper = document.querySelector('.wrapper-top-cart');
    if (!wrapper) return;
    var dropdown = wrapper.querySelector('[data-header-cart-dropdown]');
    var link = wrapper.querySelector('.cart-link');
    if (!dropdown) return;

    var body = dropdown.querySelector('[data-hcd-body]');
    var routes = {
      cart: (link && link.getAttribute('href')) || '/cart',
      all: '/collections/all'
    };
    var busy = false;

    function setCount(n) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-hcd-count]').forEach(function (el) {
        el.textContent = n;
      });
    }

    function render(cart) {
      if (body) body.innerHTML = buildBody(cart, routes);
      if (cart) setCount(cart.item_count);
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    function changeLine(line, qty) {
      if (busy) return;
      busy = true;
      dropdown.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {})
        .then(function () { busy = false; dropdown.classList.remove('is-busy'); });
    }

    function clearCart() {
      if (busy) return;
      busy = true;
      dropdown.classList.add('is-busy');
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {})
        .then(function () { busy = false; dropdown.classList.remove('is-busy'); });
    }

    var hoverCapable = window.matchMedia('(hover: hover)').matches;
    wrapper.addEventListener('mouseenter', refresh);

    if (link) {
      link.addEventListener('click', function (e) {
        if (!hoverCapable) return; // touch: navigate to the cart page
        e.preventDefault();
        var open = dropdown.classList.toggle('is-open');
        if (open) refresh();
      });
    }

    // Delegated controls inside the dropdown.
    dropdown.addEventListener('click', function (e) {
      if (e.target.closest('[data-hcd-close]')) { e.preventDefault(); dropdown.classList.remove('is-open'); return; }
      if (e.target.closest('[data-hcd-clear]')) { e.preventDefault(); clearCart(); return; }
      var inc = e.target.closest('[data-hcd-inc]');
      var dec = e.target.closest('[data-hcd-dec]');
      if (inc || dec) {
        e.preventDefault();
        var li = (inc || dec).closest('[data-hcd-item]');
        if (!li) return;
        var line = parseInt(li.getAttribute('data-line'), 10);
        var cur = parseInt(li.querySelector('[data-hcd-qty]').value, 10) || 1;
        changeLine(line, inc ? cur + 1 : cur - 1); // qty 0 removes the line
      }
    });

    // Refresh when other parts of the site change the cart (e.g. reco quick-add).
    document.addEventListener('cart:refresh', function (e) {
      if (e.detail && e.detail.cart) render(e.detail.cart);
      else refresh();
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) dropdown.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdown.classList.remove('is-open');
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
